import React, { Component } from "react";
import { Col, Row } from "antd";
import "./dashboard.css";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import DashboardUsers from "./DashboardUsers";
import DashboardAssets from "./DashboardAssets";
import DashboardMyPlan from "./DashboardMyPlan";
import DashboardExtraFeatures from "./DashboardExtraFeatures";
import DashboardMyAccount from "./DashboardMyAccount";
import {
  getPlanServices,
  updatePlanServicesByUser
} from "../../actions/PlanServicesAction";
import DashboardBin from "./DashboardBin";
import AddModalUser from "./user-modal/AddModalUser";
import ExtraPaymentModal from "./extra-payment-modal/ExtraPaymentModal";
import { getUsers } from "../../actions/UsersAction";
import { getPlanServicesByUser } from "../../actions/PlanServicesAction";
import {} from "../../actions/ClientAction";
import { getTrashItems } from "../../actions/TrashAction";
import BunkeyDashboardTour from "../tour/BunkeyDashboardTour";
import { getClientDataById } from "../../actions/ClientAction";
import DashboardDownloads from "./DashboardDownloads";
import DashboardLogin from "./DashboardLogin";
import DashboardUsersAssets from "./DashboardUsersAssets";
import { isEnterpriseUser } from "../../utils/plan-utils";

const GUTTER = 40;

export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showExtraPaymentModal: false,
      showAddModalUser: false,
      newData: []
    };
  }

  componentDidMount() {
    const { workclient } = this.props;
    this.props.getPlanServices();
    this.props.getClientDataById(workclient);
    this.props.getPlanServicesByUser(workclient);
    this.props.getUsers(workclient, 1, null, true);
    this.props.getTrashItems(workclient);
  }

  handleShowAddModalUser = () => {
    this.setState({
      showAddModalUser: true
    });
  };
  handleHiddenAddModalUser = () => {
    this.setState({
      showAddModalUser: false
    });
  };

  handleShowModalExtraPayment = initialPlanService => {
    this.setState({
      showExtraPaymentModal: true,
      initialPlanService: initialPlanService
    });
  };

  handleHiddenModalExtraPayment = () => {
    this.setState({
      showExtraPaymentModal: false
    });
    const { workclient } = this.props;
    this.props.getClientDataById(workclient);
  };

  componentDidUpdate(prevProps) {
    const { workclient } = this.props;
    if (
      prevProps.planServices.fetchingUserServices &&
      !this.props.planServices.fetchingUserServices
    ) {
      this.props.getClientDataById(workclient);
    }
  }

  render() {
    const {
      data,
      user,
      intl,
      contractedUsers,
      workclient,
      client,
      contractedSpace,
      newColor,
      trashItems
    } = this.props;
    const { showExtraPaymentModal, showAddModalUser } = this.state;

    const registeredUsers = data.filter(
      user =>
        user.status &&
        user.typeRoleFilter === "Infinite" &&
        user.email.indexOf("@bunkey.tv") === -1 &&
        user.roleLower !== "superadmin"
    ).length;

    const isAdminOrSuperadmin =
      user.role === "admin" || user.clientRole === "admin";
    // const isSuperadmin = user.role === "admin";
    return (
      <React.Fragment>
        <div id="Dashboard">
          <BunkeyDashboardTour />
          <AddModalUser
            showAddModalUser={showAddModalUser}
            handleShowAddModalUser={this.handleShowAddModalUser}
            handleHiddenAddModalUser={this.handleHiddenAddModalUser}
          />
          <ExtraPaymentModal
            showModalExtraPayment={showExtraPaymentModal}
            handleHiddenModalExtraPayment={this.handleHiddenModalExtraPayment}
            initialPlanService={this.state.initialPlanService}
          />
          <div className="title-bar">
            <div className="container" style={{ borderLeftColor: newColor }}>
              <span>{intl.formatMessage({ id: "control_panel" })}</span>
              <div
                style={{
                  display: "block",
                  float: "right",
                  marginRight: 10,
                  marginTop: 10
                }}
              ></div>
            </div>
          </div>
          <div className="container">
            <Row gutter={GUTTER}>
              <Col span={24}></Col>
              {/*  Nuevo diseño */}
              {isAdminOrSuperadmin && (
                <Col xxl={9} xl={9} lg={9} md={24} sm={24} xs={24}>
                  <DashboardUsers
                    contractedUsers={contractedUsers}
                    registeredUsers={registeredUsers}
                    handleShowAddModalUser={this.handleShowAddModalUser}
                  />
                </Col>
              )}
              {isAdminOrSuperadmin && (
                <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                  <DashboardAssets
                    workclient={workclient}
                    contractedSpace={contractedSpace}
                    handleShowAddModalUser={this.handleShowAddModalUser}
                  />
                </Col>
              )}
              {isAdminOrSuperadmin && (
                <Col xxl={9} xl={9} lg={9} md={24} sm={24} xs={24}>
                  <DashboardMyPlan
                    contractedUsers={contractedUsers}
                    contractedSpace={contractedSpace}
                    client={client}
                  />
                </Col>
              )}
              {isAdminOrSuperadmin && !isEnterpriseUser(client) && (
                <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                  <DashboardExtraFeatures
                    handleShowModalExtraPayment={
                      this.handleShowModalExtraPayment
                    }
                  />
                </Col>
              )}
              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <DashboardMyAccount user={user} />
              </Col>
              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <DashboardBin
                  trashItems={trashItems}
                  isAdminOrSuperadmin={isAdminOrSuperadmin}
                />
              </Col>
              {isAdminOrSuperadmin && (
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                  <DashboardDownloads user={user} />
                </Col>
              )}
              {isAdminOrSuperadmin && (
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                  <DashboardLogin user={user} />
                </Col>
              )}
              {isAdminOrSuperadmin && (
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                  <DashboardUsersAssets user={user} />
                </Col>
              )}
            </Row>
            {/* Antiguo diseño 1 */}
            {/* {isAdminOrSuperadmin &&
            <Row gutter={GUTTER}>
              <Col xxl={9} xl={9} lg={9} md={24} sm={24} xs={24}>
                <DashboardUsers
                  contractedUsers={contractedUsers}
                  registeredUsers={registeredUsers}
                  handleShowAddModalUser={this.handleShowAddModalUser}
                />
              </Col>
              <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                <DashboardAssets 
                  workclient={workclient}
                  contractedSpace={contractedSpace}
                  handleShowAddModalUser={this.handleShowAddModalUser}
                />
              </Col>
            </Row>
          } */}

            {/* {isAdminOrSuperadmin &&
            <Row gutter={GUTTER}>
              <Col xxl={9} xl={9} lg={9} md={24} sm={24} xs={24}>
                <DashboardMyPlan 
                  contractedUsers={contractedUsers}
                  contractedSpace={contractedSpace}
                  client={client}
                />
              </Col>
              {
                !isEnterpriseUser(client) && <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                  <DashboardExtraFeatures 
                    handleShowModalExtraPayment={this.handleShowModalExtraPayment}
                  />
                </Col>
              }
            </Row>
          } */}
            {/* <Row gutter={GUTTER}>
            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
              <DashboardMyAccount user={user}/>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
              <DashboardBin
                trashItems = {trashItems}
                isAdminOrSuperadmin = {isAdminOrSuperadmin}
              />
            </Col>
          </Row> */}
            {/* {isAdminOrSuperadmin && <Row gutter={GUTTER}>
            {isAdminOrSuperadmin && <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
              <DashboardDownloads user={user}/>
            </Col>}
            {isSuperadmin && <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
              <DashboardLogin user={user}/>
            </Col>}
            {isSuperadmin && <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
              <DashboardUsersAssets user={user}/>
            </Col>}
          </Row>} */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    contractedUsers:
      state.client && state.client.data
        ? state.client.data.contractedUsers
        : null,
    contractedSpace:
      state.client && state.client.data
        ? state.client.data.contractedSpace
        : null,
    data: state.users.data,
    workclient: state.client.workclient,
    user: state.authUser.user,
    client: state.client.data,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    planServices: state.planServices,
    trashItems: state.trash.trashItems,
    tourDashboard: state.tours.tourDashboard
  };
};

const mapDispatchToProps = {
  getPlanServices,
  getUsers,
  getPlanServicesByUser,
  getClientDataById,
  getTrashItems,
  updatePlanServicesByUser
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard))
);
